import React from "react";
import styles from "./Page01.module.scss";
import { Accordion, AccordionItem } from "@src/lms/jelly/extensions/ui";

interface Lesson0502Page01Props {
  col1Image: string;
  col2Image: string;
  col3Image: string;
  stepText: string;
  col1Description: string;
  col2Description: string;
  col3Description: string;
}

export const Lesson0502Page01: React.FC<Lesson0502Page01Props> = (props) => {
  return (
    <div className={styles.pageWrapper}>
      <div className={`${styles.col1} ${styles.col}`}>
        <div className={styles.imgWrapper}>
          <img src={props.col1Image} />
        </div>
        <div className={styles.accordionWrapper}>
          <Accordion>
            <div className={styles.accordion}>
              <AccordionItem id={"1_1"} title={`${props.stepText} 1`}>
                {props.col1Description}
              </AccordionItem>
            </div>
          </Accordion>
        </div>
      </div>
      <div className={`${styles.col1} ${styles.col}`}>
        <div className={styles.imgWrapper}>
          <img src={props.col2Image} />
        </div>
        <div className={styles.accordionWrapper}>
          <Accordion>
            <div className={styles.accordion}>
              <AccordionItem id={"2_1"} title={`${props.stepText} 2`}>
                {props.col2Description}
              </AccordionItem>
            </div>
          </Accordion>
        </div>
      </div>
      <div className={`${styles.col1} ${styles.col}`}>
        <div className={styles.imgWrapper}>
          <img src={props.col3Image} />
        </div>
        <div className={styles.accordionWrapper}>
          <Accordion>
            <div className={styles.accordion}>
              <AccordionItem id={"3_1"} title={`${props.stepText} 3`}>
                {props.col3Description}
              </AccordionItem>
            </div>
          </Accordion>
        </div>
      </div>
    </div>
  );
};
